import { Trans } from "react-i18next";
import i18next from "i18next";

export default ({ fields, setFields, invalidFields, state, actions }) => {
  let borderStyle = invalidFields && invalidFields.selectChildBirth ? '2px solid red' : 'none';
  return (
    <>
      <fieldset>
        <div role="group" className={`standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset pregnant-div ${!(state && state.isTravelAid2) ? "" : "travelAidPregDiv"}`}>
          <div className= {`${!(state && state.isTravelAid2)? "standby-col standby-col-shrink standby-form-legend" : "childbirth-label"}`}>
            <legend>
            {!state.isTravelAid2 ?
            <h2 className="standby-form-legend-text">
            {!(state && state.isTravelAid2)?fields.childBirthName: <Trans i18nKey="findcareoption.Start.Childbirth">
                        Recent childbirth
                      </Trans>}
            </h2> 
            :
            <h5 className="standby-form-legend-text">
            {!(state && state.isTravelAid2)?fields.childBirthName: <Trans i18nKey="findcareoption.Start.Childbirth">
                        Recent childbirth
                      </Trans>}
            </h5>}
            </legend>
          </div>
          <div className= {`${!state.isTravelAid2? "standby-col standby-form-inline-fields" : "childbirth-radio-container"}`}>
            <label id="lblchildbirthYes" htmlFor="rbchildbirthYes" className= {`${!state.isTravelAid2? "select-child-birth-label1 child-birth-container" : "childbirth-yes-label"}`} style={{border: borderStyle}}>
              <input
                type="radio"
                name="selectChildBirth"
                id="rbchildbirthYes"
                value="Yes"
                aria-label={i18next.t("findcareoption.Start.Childbirth")+ " " + i18next.t("findcareoption.Yes")}
                className= {`${!(state && state.isTravelAid2)? "select-child-birth-radio" : "childbirth-radio-yes"}`}
                checked={fields.selectChildBirth === "Yes"}
                onClick={
                  () => {
                    setFields({ selectChildBirth: "Yes" });
                    if (!document.getElementById("rbchildbirthYes").checked 
                        && !document.getElementById("rbchildbirthNo").checked)
                    {
                        document.getElementById('lblchildbirthYes').style.border = 'borderStyle';
                        document.getElementById('lblchildbirthNo').style.border = 'borderStyle';
                        document.getElementById('errorIsRecentChildBirth').style.display = 'block';
                    }
                    else
                    {
                        invalidFields.selectChildBirth = '';
                        document.getElementById('lblchildbirthYes').style.border = '';
                        document.getElementById('lblchildbirthNo').style.border = '';
                        document.getElementById('errorIsRecentChildBirth').style.display = 'none';
                    }
                  }
                }
                onChange={() => {}}
              />
              <span className= {`${!state.isTravelAid2? "checkmark" : "childbirth-radio-1"}`}></span>
              <span className= {`${!state.isTravelAid2? "child-option" : "span-childbirth-yes"}`}>
                <Trans i18nKey="findcareoption.Yes">Yes</Trans>
              </span>
            </label>
            <label id="lblchildbirthNo" htmlFor="rbchildbirthNo" className= {`${!state.isTravelAid2? "select-child-birth-label2 child-birth-container" : "childbirth-no-label"}`} style={{border: borderStyle}}>
              <input
                type="radio"
                name="selectChildBirth"
                id="rbchildbirthNo"
                value="No"
                aria-label={i18next.t("findcareoption.Start.Childbirth")+ " " + i18next.t("findcareoption.No")}
                className= {`${!state.isTravelAid2?"select-child-birth-radio" : "childbirth-radio-no"}`}
                checked={fields.selectChildBirth === "No"}
                onClick={
                  () => {
                    setFields({ selectChildBirth: "No" });
                    if (!document.getElementById("rbchildbirthYes").checked 
                        && !document.getElementById("rbchildbirthNo").checked)
                    {
                        document.getElementById('lblchildbirthYes').style.border = 'borderStyle';
                        document.getElementById('lblchildbirthNo').style.border = 'borderStyle';
                        document.getElementById('errorIsRecentChildBirth').style.display = 'block';
                    }
                    else
                    {
                        invalidFields.selectChildBirth = '';
                        document.getElementById('lblchildbirthYes').style.border = '';
                        document.getElementById('lblchildbirthNo').style.border = '';
                        document.getElementById('errorIsRecentChildBirth').style.display = 'none';
                    }
                  }
                }
                onChange={() => {}}
              />
              <span className= {`${!state.isTravelAid2?"checkmark" : "span-childbirth-no"}`}></span>
              <span className= {`${!state.isTravelAid2?"child-option" : "span-childbirth-no-1"}`}>
                <Trans i18nKey="findcareoption.No">No</Trans>
              </span>
            </label>
          </div>
        </div>
      </fieldset>
      <div id="errorIsRecentChildBirth" className="errormessage-phone"
         style={{ display: invalidFields.selectChildBirth 
         ? "block" 
         : "none" 
         }}>
          {i18next.t("findcareoption.Start.errorMessages.recentChildBirth")}
      </div>
    </>
)};
